// Крошечный стейт с подпиской: set() мержит верхний уровень и зовёт слушателей.
// Секции UI перерисовываются целиком — данных мало, DOM-диффинг не нужен.
export function createState(initial = {}) {
  const listeners = new Set();
  const state = {
    config: null, // ответ /api/config
    map: null, // индекс карты (indexMap)
    error: null, // фатальная ошибка загрузки (текст)
    guests: { adults: 2, children: 0 },
    dates: { checkin: null, checkout: null },
    // живые длины для выбранного заезда; key = `${from}|${adults}`
    lengths: { key: null, data: null, loading: false, error: null },
    // мгновенные кандидаты выезда из /api/checkouts (SQLite, без цен); key как у lengths
    checkouts: { key: null, data: null, loading: false, error: null },
    // снимок на момент «Найти» — карточки не прыгают при дальнейших кликах
    search: null, // {checkin, checkout, adults, children, L, lengthsData}
    // экран оформления (T6); phase: loading → form → done. В фазе form HTML стабилен —
    // значения полей живут в DOM, а ошибки обновляются точечно (см. index.js)
    // formToken/formTokenAt — токен формы из /payment-options и момент его получения (T10d)
    checkout: null, // {card, search, phase, options, optionsError, formToken, formTokenAt, services, servicesError, result}
    // экран статуса брони по query-параметру возврата с оплаты
    status: null, // {orderToken, loading, data, error}
    // мягкий гейт T9: true = страница открыта без ?key= — показываем тихую заглушку
    denied: null,
    // finding: true = «Найти» ждёт живые цены — кнопка показывает «Ищем…» и не даблкликается;
    // "retry" = повтор quote после таймаута/обрыва (T24) — кнопка «Пробуем ещё раз…»
    ui: { modal: null, monthIndex: 0, toast: null, finding: false },
    ...initial,
  };

  return {
    get: () => state,
    set(patch) {
      Object.assign(state, patch);
      for (const fn of listeners) fn(state);
    },
    subscribe(fn) {
      listeners.add(fn);
      return () => listeners.delete(fn);
    },
  };
}
